import { CheckCircle2, FileText, LogOut } from 'lucide-react';
import { Button } from '@/components/shadcn/button';
import { Card, CardContent } from '@/components/shadcn/card';

interface CompletionScreenProps {
  onNewSubmission: () => void;
  submitterEmail?: string;
}

export function CompletionScreen({ onNewSubmission, submitterEmail }: CompletionScreenProps) {
  const handleExit = () => {
    window.location.href = 'http://lvh.me:3000/terminal/dashboard';
  };

  return (
    <div className='min-h-screen bg-background flex items-center justify-center p-6'>
      <Card className='w-full max-w-3xl border border-gray-200 shadow-sm rounded-2xl'>
        <CardContent className='p-10 text-center space-y-7'>
          <div className='flex justify-center'>
            <div className='w-16 h-16 bg-green-600/10 rounded-full flex items-center justify-center'>
              <CheckCircle2 className='w-9 h-9 text-green-700' />
            </div>
          </div>

          <div className='space-y-2 max-w-2xl mx-auto'>
            <h1 className='text-3xl font-semibold text-foreground'>Submission Complete</h1>
            <p className='text-muted-foreground text-base leading-relaxed'>
              Your department&apos;s input has been recorded. SEIN will combine submissions across departments to design a unified solution.
            </p>
          </div>

          <div className='bg-gray-100/70 rounded-xl p-6 text-left space-y-3'>
            <h3 className='font-semibold text-foreground text-lg'>What happens next?</h3>
            <ul className='space-y-2 text-sm text-muted-foreground'>
              <li className='flex items-start gap-2'>
                <span className='text-foreground mt-0.5'>•</span>
                <span>SEIN Terminal will aggregate responses from all participating departments</span>
              </li>
              <li className='flex items-start gap-2'>
                <span className='text-foreground mt-0.5'>•</span>
                <span>Common pain points will be identified and weighted by frequency</span>
              </li>
              <li className='flex items-start gap-2'>
                <span className='text-foreground mt-0.5'>•</span>
                <span>A unified proposal will be generated based on collective input</span>
              </li>
              <li className='flex items-start gap-2'>
                <span className='text-foreground mt-0.5'>•</span>
                <span>Your team will receive a copy of the final discovery report</span>
              </li>
            </ul>
          </div>

          <div className='flex flex-col sm:flex-row gap-3 justify-center items-stretch pt-2'>
            <Button variant='outline' onClick={onNewSubmission} className='gap-2 bg-white'>
              <FileText className='w-4 h-4' />
              Submit another department response
            </Button>
            <Button onClick={handleExit} className='gap-2 bg-green-700 hover:bg-green-800 text-white'>
              <LogOut className='w-4 h-4' />
              Exit
            </Button>
          </div>

          {submitterEmail && (
            <p className='text-xs text-muted-foreground pt-4 border-t border-border'>
              A confirmation email has been sent to {submitterEmail}
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
